import { Component } from '@angular/core'
import { environment } from '@exchange/environment'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

@Component({
  selector: 'app-uploaders-list',
  templateUrl: './uploaders-list.component.html',
  styleUrls: ['./uploaders-list.component.scss'],
  standalone: false
})
export class UploadersListComponent {
  iframeUrl: SafeResourceUrl

  constructor(private sanitizer: DomSanitizer) {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.reactAppUrl}/system/uploaders`
    )
  }
}
